import { Form } from 'factorial-form'

class Document extends Form {
  constructor(values: {}) {
    super(values, {
      filename: 'string',
      public: 'boolean',
      type: 'string',
      folder_id: 'string',
    })
  }
}

export default Document
